export const isTouchDevice = matchMedia('(hover: none)').matches;
